<template>
  <div class="d-flex flex-column flex-column-fluid mb-10 ">
    <div id="kt_app_content" class="app-content  flex-column-fluid ">
        <div id="kt_app_content_container" class="app-container  container-fluid " style="margin-top: 30px!important;">
            <div class="row g-7">
                <div class="col-lg-3 col-xl-3 col-12 mt-30">
                    <div class="card card-flush">
                        <div class="card-body">
                            <ul class="nav nav-tabs nav-pills nav-fill border-0 flex-column mb-3 mb-md-0 fs-6">
                              <template v-for="(item, index) in menuItems" :key="index">
                                <li class="nav-item me-0 mt-4" v-if="$can(item?.permission) && $canAccess(item?.module)">
                                  <router-link class="nav-link btn btn-light btn-text-gray-600 btn-icon-gray-600 "
                                               :class="[
                                              {'active btn-primary': $route.name == item.routeName},
                                              {'active btn-primary': item.childRouteName && item.childRouteName.length && item?.childRouteName.includes($route.name)},
                                          ]"
                                               :to="{ name: item.routeName }">
                                    <div class="d-flex align-items-center justify-content-start ">
                                      <i :class="item.icon" class="m-1" ></i>
                                      <span >{{ $t(item.title) }}</span>
                                    </div>
                                  </router-link>
                                </li>
                              </template>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-9 col-12">
                    <div v-if="$route.name == 'settings-new'" class="card card-flush h-lg-100" id="kt_contacts_main">
                        <div class="card-body p-0">

                            <div class="text-center px-4">
                              <Img filename="empty.png" class="mw-100 mh-300px" alt="" />
                            </div>
                        </div>
                    </div>
                    <router-view v-else></router-view>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Img from "@/components/Img.vue";
import abilities from "@/composables/abilities";
import {mapGetters} from 'vuex'
import moduleAbilities from "@/composables/moduleAbilities";

export default {
  name: "BaseSettingLayout",
  data() {
    return {
      menuItems: [
        {
          routeName: 'profile',
          title: 'breadcrumbs.profile',
          icon: 'bi bi-shield-check',
          childRouteName: [],
          permission: [abilities.VIEW_USER_PROFILE]
        },
        {
          routeName: 'user-others',
          title: 'user.others',
          icon: 'bi bi-card-heading',
          childRouteName: [],
          permission: [abilities.VIEW_USER_PROFILE],
          module : moduleAbilities.RH_PAYSLIP,
          query: {viewType: 'list'}
        },
        {
          routeName: 'absences',
          title: 'breadcrumbs.absences',
          icon: 'fas fa-umbrella-beach',
          childRouteName: [],
          permission: [abilities.VIEW_USER_PROFILE],
          module : moduleAbilities.RH_ABSENCE,
          query: {viewType: 'list'}
        },
        {
          routeName: 'user-contracts',
          title: 'user.contracts',
          icon: 'bi bi-journals',
          childRouteName: [],
          module : moduleAbilities.RH_CONTRACT,
          permission: [abilities.VIEW_USER_PROFILE]
        },
        
        {
          routeName: 'user-payslips',
          title: 'user.payslips',
          icon: 'fas fa-wallet',
          childRouteName: [],
          permission: [abilities.VIEW_USER_PROFILE],
          module : moduleAbilities.RH_PAYSLIP,
        } ,
        {
          routeName: 'config-imap',
          title: 'mail.config_imap',
          icon: 'fas fa-envelope',
          childRouteName: [],
          permission: [abilities.VIEW_USER_PROFILE],
          module : moduleAbilities.COMMUNICATION_MAIL,
        },
        {
          routeName: 'settings-signatures',
          title: 'mail.signatures',
          icon: 'fas fa-edit',
          childRouteName: ['settings-signatures'],
          permission: [],
        },
        {
          routeName: 'settings-notices',
          title: 'setting.notices',
          icon: 'fas fa-bell',
          permission: []
        }
      ],
    }
  },
}
</script>

<style scoped>

</style>
